import validationError from './validator';

export {validationError};



// WEBPACK FOOTER //
// ./src/actions/Navigation/index.ts